import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box,  IconButton, Switch } from '@mui/material';
import  VisibilityIcon from "@mui/icons-material/Visibility";

export default function CustomTable({ columns, rows, setLoader, page, setPage, rowsPerPage, setRowsPerPage, handleEdit, handleDelete, handleStatus, handleView, totalCount, handleStatusChange,service }) {
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage+1)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(1)
  }

  console.log(rows);

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none", border: "1px solid #cacaca" }}>
      <TableContainer sx={{ maxHeight: 700 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {rows?.length > 0 ?
          <TableBody>
            {rows.map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  {columns.map((column) => {
                    const value = row[column.id]
                    return ( 
                      <>
                        <TableCell key={column.id} align={column.align}>
                          {typeof value === "string" && value.includes(",") ? value.split(",").map((val, index) => <div key={index}>{val.trim()}</div>) : value} 
                          {column.id === "status" && <Switch onChange={() => handleStatusChange(row)} checked={row?.status} color="success" />}
                          {column.id === "image" && <img src={row.output} alt={row.name} width="50" height="50" />}
                          {column.id === "action" &&
                            column.actionType.map((a) => {
                              return (
                                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, alignItems: "center" }}>
                                  {a.view && (
                                    <IconButton onClick={() => handleView(row)} color="primary">
                                      <VisibilityIcon />
                                    </IconButton>
                                  )}
                                  {a.edit && (
                                    <IconButton onClick={() => handleEdit(row)} color="primary">
                                      <EditIcon />
                                    </IconButton>
                                  )}

                                  {a.delete && (
                                    <IconButton onClick={() => handleDelete(row._id)}>
                                      <DeleteIcon />
                                    </IconButton>
                                  )}
                                </Box>
                              )
                            })}
                        </TableCell>
                      </>
                    )
                  })}
                </TableRow>
              )
            })}
          </TableBody>
          :
          <TableBody>
          <TableRow>
            <TableCell align="center" colSpan={columns.length}>
            No Result Found
            </TableCell>
          </TableRow>
          </TableBody>
          }
        </Table>
      </TableContainer>
      {!service &&(
              <TablePagination rowsPerPageOptions={[10, 25, 100]} component="div" count={totalCount} rowsPerPage={rowsPerPage} page={page-1} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
      )}
    </Paper>
  )
}
